<script>
// CommitChart.js
import { Bar, mixins } from 'vue-chartjs'
// Chart.defaults.global.defaultFontFamily = 'Muli'
// Chart.defaults.global.defaultFontSize = 14

export default {
  extends: Bar,
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options'],
  mounted () {
    // Overwriting base render method with actual data.
    this.renderChart(this.chartData, this.options)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/charts/MiniBarChart.vue